import { useQuery } from '@tanstack/react-query';

import { fetchJson } from '../api.ts';

/**
 * Read-only file_clusters fetched for the settings pages so users
 * can see which path patterns are attributed to each derivedContext / BF.
 * The matrix views consume cluster data through the composer, not
 * this hook — this is purely for the settings detail rendering.
 */

export interface FileCluster {
  object: 'file_cluster';
  id: string;
  pattern: string;
  priority: number;
  derived_context_ids: string[];
  business_function_ids: string[];
  skill_ids: string[];
  skipped: boolean;
  effective_from: string;
  effective_to: string | null;
}

interface ListResponseBody {
  object: 'list';
  url: string;
  has_more: boolean;
  data: FileCluster[];
}

export function useFileClusters(orgSlug: string | null) {
  return useQuery({
    queryKey: orgSlug ? (['file_clusters', orgSlug] as const) : (['file_clusters', null] as const),
    queryFn: async () => {
      if (!orgSlug) throw new Error('useFileClusters called without orgSlug');
      const body = await fetchJson<ListResponseBody>(`/v1/orgs/${orgSlug}/file_clusters`);
      return body.data;
    },
    enabled: !!orgSlug,
    staleTime: 30_000,
  });
}
